import LinkTile from '../LinkTile';
import { type ThreeColumnLinkProps } from './ThreeColumnLink.types';

const ThreeColumnLink: React.FC<ThreeColumnLinkProps> = ({
  showTitle = true,
  title,
  items,
}) => (
  <div className="three-col-link-block">
    {showTitle && title ? (
      <h2 className="three-col-link-block__heading" data-aos="fade-in">
        {title}
      </h2>
    ) : null}

    {items && (
      <div className="three-col-link-block__columns">
        {items &&
          items.map((item, index) => (
            <LinkTile
              key={index}
              position={index + 1}
              disableCard={false}
              {...item}
            />
          ))}
      </div>
    )}
  </div>
);

export default ThreeColumnLink;
